/**
 * Crea el fondo del juego
 * @param {*} scene 
 */
export function crearFondoAlfombra(scene) {
  const fondoAlfombra = scene.add.image(500, 250, "fondoAlfombra");
  fondoAlfombra.setDepth(-100);
}